import { render, staticRenderFns } from "./ProductsTypesEditPage.vue?vue&type=template&id=78a3a61b&scoped=true&"
import script from "./ProductsTypesEditPage.vue?vue&type=script&lang=js&"
export * from "./ProductsTypesEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a3a61b",
  null
  
)

export default component.exports